module.exports = __webpack_public_path__ + "static/media/1_lead_a.7895055d.ogg";